/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramFavouritesUserControllerFindAllQueryResponse,
  TelegramFavouritesUserControllerFindAllQueryParams,
  TelegramFavouritesUserControllerFindAll401,
} from '../types/TelegramFavouritesUserControllerFindAll.ts';

function getTelegramFavouritesUserFindAllUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/favourites` as const };
  return res;
}

/**
 * {@link /api/user/telegram/favourites}
 */
export async function telegramFavouritesUserFindAll(
  params?: TelegramFavouritesUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramFavouritesUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramFavouritesUserControllerFindAll401>,
    unknown
  >({ method: 'GET', url: getTelegramFavouritesUserFindAllUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
